import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import "reflect-metadata";
import React from 'react';
import { createRoot } from 'react-dom/client';
import TripPlannerApp from "./planner/TripPlannerApp";

const root = createRoot(document.getElementById("tripgo-planner")!);
root.render(<TripPlannerApp />);

// if (process.env.NODE_ENV === 'development') {
//     require("../../../mock/mock.js");
// }